// @flow
import React,{useRef} from 'react';
import * as moment from 'moment';
// import Icon from '@material-ui/core/Icon';
// import Button from '@material-ui/core/Button';
import classes from './Invoice.module.css';
import OrderHeader from '../order-header/OrderHeader';
import MachinePickupSection from '../machine-pickup-section/MachinePickupSection';
import OrderDetailsSection from '../order-details-section/OrderDetailsSection';
// import RatingDlg from '../../components/rating-dlg/RatingDlg';
import ViewAddress from '../../containers/view-address/ViewAddress';
import {
	ORDER_STATUS,
	MACHINE_ORDER,
	COMPLETED_ORDER,
	VIRTUAL_ORDER,
	CANCELLED_ORDER,
	PICKED_UP,
	ACTIVE_ORDER,
	PARTIAL_DELIVERED_ORDER,
	// RECEIVED_ORDER,
	KIOSK_ORDER,
	FAILED_ORDER, RECEIVED_ORDER, CONFIRMED_ORDER,
} from '../../constants';
import OrderProgress from '../order-progress/OrderProgress';
import ExpressDelivery from '../../icons/ExpressDelivery';
import PropTypes from "prop-types";
import ServerOpendoorButton from "../server-opendoor-button/ServerOpendoorButton";
import ServerOpendoor_handleEvent from "../server-opendoor-button/ServerOpendoorButton";



const handleOpenDoorClick=(event,history) => {
	history.push()
};

type Props = {
	orderDetails: Object,
	history: any,
	submitRating: (Object) => void,
	logEvent: (string, ?{ [key: string]: number | string }) => void,
	generateQRCode: () => void,
	pod: { [key: string]: any },
	openRatingDlg: () => void,
	cancelledOrderIds?: Set<string>,
	handleSelectOrder: Function,
	openDoorProcessing: boolean,
	setOpenDoorProcessing: Function,
};

// const stars = [1, 2, 3, 4, 5];

export default function Invoice({
	orderDetails = {},
	history={},
	submitRating,
	logEvent,
	generateQRCode,
	pod,
	openRatingDlg,
	cancelledOrderIds = new Set(),
	handleSelectOrder,
	openDoorProcessing,
	setOpenDoorProcessing,
}: Props) {
	let totalItems = 0;
	const doors = {};
	const order_details=orderDetails;
	const { order_items, delivery_details_json } = orderDetails;
	const deliveryDetails = delivery_details_json ? JSON.parse(delivery_details_json) : {};
	const { agent_details: { contact = '' } = {} } = deliveryDetails;
	// const [ratingDlg, openRatingDlg] = useState<boolean>(false);
	const order_url="/orders/"+orderDetails.order_id+"/process";
	const bQRViewer = useRef<boolean>(false);
	const bServer_Order = useRef<boolean>(false);
	const bVending_Order = useRef<boolean>(false);
	if (pod && pod.vm_id === orderDetails.vm_id) {
		const { webapp_config = '' } = pod;
		if (webapp_config) {
			try {
				const webappConfig = JSON.parse(webapp_config);
				const { qr_viewer = 0 } = webappConfig;
				const { server_order = 0 } = webappConfig;
				const { vending_order = 0 } = webappConfig;
				if (qr_viewer) {
					bQRViewer.current = true;
				}
				if (server_order) {
					bServer_Order.current = true;
				}
				if (vending_order) {
					bVending_Order.current = true;
				}
				//console.log(bVending_Order)
				//console.log(webappConfig)

			} catch (error) {}
		}
	}

	if (order_items && Array.isArray(order_items)) {
		for (const { purchased_qty, qty, door_id } of order_items) {
			totalItems += orderDetails.type_of_order === MACHINE_ORDER ? +purchased_qty || +qty : +qty;
			doors[door_id] = 1;
		}
	}

	const doorSteps = [];
	const doorIds = Object.keys(doors);
	switch (doorIds.length) {
		case 0:
			break;
		case 1:
			doorSteps.push(`Pick items from Door${doorIds[0]} \n and close it`);
			break;
		case 2:
			doorSteps.push(`Pick items \n from Door${doorIds[0]}`);
			doorSteps.push(`Close Door${doorIds[0]} \n and open Door${doorIds[1]}`);
			doorSteps.push(`Pick items \n from Door${doorIds[1]}`);
			break;
		case 3:
			doorSteps.push(`Pick items \n from Door${doorIds[0]} and close it`);
			doorSteps.push(`Pick items \n from Door${doorIds[1]} and close it`);
			doorSteps.push(`Pick items \n from Door${doorIds[2]} and close it`);
			break;
		default:
			doorSteps.push(`Pick items \n from Door${doorIds[0]} and close it`);
			doorSteps.push(`Pick items \n from Door${doorIds[1]} and close it`);
			doorSteps.push(`Continue the same steps for the rest of the doors`);
			break;
	}

	// const generateOR = () => {
	// 	generateQRCode();
	// };

	return (
		<section className={classes.pageContainer}>
			<OrderHeader
				orderDetails={orderDetails}
				index={0}
				totalOrders={1}
				totalItems={totalItems}
				isExpanded={true}
				onToggleExpand={() => {}}
				cancelledOrderIds={cancelledOrderIds}
				showToggleButton={false}
				isOrderActive={(order) => {
					const isActive = (order.status === ACTIVE_ORDER || order.status === RECEIVED_ORDER) &&
						!cancelledOrderIds.has(order.order_id);
					console.log('🔍 OrderHeader isOrderActive check:', {
						orderId: order.order_id,
						status: order.status,
						isInCancelledIds: cancelledOrderIds.has(order.order_id),
						cancelledOrderIds: Array.from(cancelledOrderIds),
						isActive
					});
					return isActive;
				}}
			/>
			<MachinePickupSection
				orderDetails={orderDetails}
				isOrderActive={(order) => {
					const isActive = (order.status === ACTIVE_ORDER || order.status === RECEIVED_ORDER) &&
						!cancelledOrderIds.has(order.order_id);
					console.log('🔍 MachinePickupSection isOrderActive check:', {
						orderId: order.order_id,
						status: order.status,
						isInCancelledIds: cancelledOrderIds.has(order.order_id),
						cancelledOrderIds: Array.from(cancelledOrderIds),
						isActive
					});
					return isActive;
				}}
				selectedPod={pod}
				accessCode={orderDetails.access_code}
				bQRViewer={bQRViewer.current}
				bServer_Order={bServer_Order.current}
				bVending_Order={bVending_Order.current}
				openDoorProcessing={openDoorProcessing}
				setOpenDoorProcessing={setOpenDoorProcessing}
				handleSelectOrder={handleSelectOrder}
				history={history}
				handleSelectOrder={() => {}}
				history={history}
			/>
			{orderDetails.type_of_order === VIRTUAL_ORDER && orderDetails.delivery_address && (
				<section style={{ marginBottom: 14, padding: '0 14px' }}>
					<ViewAddress
						showMap={false}
						showError={false}
						location={orderDetails.delivery_address}
						savingAddress={false}
						editAddressMode={false}
						showEditBtn={false}
						showAddBtn={false}
					/>
				</section>
			)}
			{orderDetails.type_of_order === VIRTUAL_ORDER &&
				orderDetails.status !== CANCELLED_ORDER &&
				orderDetails.status !== COMPLETED_ORDER && <OrderProgress status={orderDetails.status} />}
			{(orderDetails.status === PICKED_UP || orderDetails.status === PARTIAL_DELIVERED_ORDER) && (
				<section className={classes.deliveryPickup}>
					<div style={{ marginRight: 10 }}>
						<span>Delivery Executive</span>
						{contact && <span>+91 {contact}</span>}
					</div>
					<ExpressDelivery />
				</section>
			)}
			<div style={{ width: '100%', alignSelf: 'stretch' }}>
				<OrderDetailsSection
					orderDetails={orderDetails}
					doorSteps={doorSteps}
					isVSorder={orderDetails.type_of_order === VIRTUAL_ORDER}
					deliveryAmount={+orderDetails.delivery_fee || 0}
					totalBillValue={(orderDetails.type_of_order === MACHINE_ORDER || orderDetails.type_of_order === KIOSK_ORDER) &&
						[ACTIVE_ORDER, CANCELLED_ORDER, FAILED_ORDER].includes(orderDetails.status)
							? orderDetails.pre_auth_amount
							: orderDetails.order_amount}
					cancelledOrderIds={cancelledOrderIds}
				/>
			</div>
		</section>
	);
}

Invoice.defaultProps = {
	orderDetails: {},
	history: {},
	openRatingDlg: () => {},
	generateQRCode: () => {},
	pod: {},
};
